import * as DateF from 'date-fns'

import { Iterable, pipe } from '@blade/std-lib'

import type { Summary } from '@root/entities/summary/model'

const DAYS_RANGE = 30

export type ChartPoint = {
  value: number
  time: string
}

const formatAxisTime = (dt: Date) => DateF.format(dt, 'yyyy-MM-dd')

const fromEntryToChartPoint = (entry: Summary.DataEntry): ChartPoint => ({
  time: formatAxisTime(entry[0]),
  value: entry[1].toNumber(),
})

export const createChartData = (
  entries: Array<Summary.DataEntry>,
): {
  chartData: Array<ChartPoint>
  placeholderData: Array<ChartPoint>
} => {
  if (entries.length >= DAYS_RANGE) {
    return {
      chartData: entries.map(fromEntryToChartPoint),
      placeholderData: [],
    }
  }

  let leadingZeros = 2

  const result = entries.map(fromEntryToChartPoint)

  while (result.length !== DAYS_RANGE && leadingZeros !== 0) {
    const oldest = result.at(0)!
    result.unshift({
      time: formatAxisTime(DateF.subDays(oldest.time, 1)),
      value: 0,
    })
    leadingZeros--
  }

  const oldest = result.at(0)!

  const placeholder = pipe(
    Iterable.range(0, 29),
    Iterable.map(
      (it): ChartPoint => ({
        value: 0,
        time: formatAxisTime(DateF.addDays(oldest.time, it)),
      }),
    ),
    Iterable.toArray,
  )

  return {
    chartData: result,
    placeholderData: placeholder,
  }
}
